import { Component } from '@theme/component';

class CustomProductRecommendationsCarousel extends Component {
  requiredRefs = ['recommendationsCarousel'];

  #swiper = null;

  connectedCallback() {
    super.connectedCallback();

    this.#initCarousel();
  }

  #initCarousel() {
    this.#swiper = new window.Swiper(this.refs.recommendationsCarousel, {
      slidesPerView: 2.1,
      spaceBetween: 12,
      breakpoints: {
        750: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        }
      },
      navigation: {
        prevEl: '.custom-product-recommendations__button--prev',
        nextEl: '.custom-product-recommendations__button--next'
      }
    });
  }
}

if (!customElements.get('custom-product-recommendations-carousel')) {
  customElements.define('custom-product-recommendations-carousel', CustomProductRecommendationsCarousel);
}